import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/logos/sh_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-4c883dc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "header__left-block" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_5 = { class: "header__right-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_router = _resolveComponent("app-router")!
  const _component_app_badge = _resolveComponent("app-badge")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_mini_cart = _resolveComponent("mini-cart")!
  const _component_verify_badge = _resolveComponent("verify-badge")!
  const _component_profile_mini = _resolveComponent("profile-mini")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_app_router, {
          href: "/",
          class: "logo",
          target: "_self"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        (_ctx.getBadgeText && _ctx.$isWindow.desktop)
          ? (_openBlock(), _createBlock(_component_app_badge, {
              key: 0,
              text: _ctx.getBadgeText,
              "icon-name": "icon-arrow-right",
              "icon-position": "left",
              size: "large",
              type: "white",
              color: "black",
              onClick: _ctx.goToUrl
            }, null, 8, ["text", "onClick"]))
          : (_ctx.$isWindow.desktop)
            ? (_openBlock(), _createBlock(_component_app_badge, {
                key: 1,
                text: "Витрина стримеров",
                size: "large",
                type: "white",
                color: "blue",
                class: "showcase",
                onClick: _ctx.goToUrl
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
        (_ctx.$isWindow.desktop && this.$route.name !== 'RequestBriefPage')
          ? (_openBlock(), _createBlock(_component_app_button, {
              key: 2,
              "icon-size": "10",
              text: "Заказать рекламную кампанию",
              "icon-name": "icon-arrow-right",
              style: {"margin-left":"20px"},
              onClick: _ctx.goToNewBrief
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (this.IS_VERIFIED)
          ? (_openBlock(), _createBlock(_component_mini_cart, {
              key: 0,
              "is-show": _ctx.isShowMiniCart
            }, null, 8, ["is-show"]))
          : _createCommentVNode("", true),
        (!this.IS_VERIFIED)
          ? (_openBlock(), _createBlock(_component_verify_badge, { key: 1 }))
          : _createCommentVNode("", true),
        _createVNode(_component_profile_mini, {
          name: _ctx.getProfileName,
          "is-show": _ctx.isShowProfile
        }, null, 8, ["name", "is-show"])
      ])
    ])
  ]))
}